
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"960","height":"640","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ed0000","d":"M0 0h900v600H0z"}}),_c('path',{attrs:{"d":"M0 180h900M0 420h900","stroke":"#fff","stroke-width":"120"}}),_c('path',{attrs:{"d":"M0 0l519.615 300L0 600z","fill":"#0050f0"}}),_c('g',{attrs:{"transform":"matrix(100 0 0 100 173.205 300)","fill":"#fff"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"transform":"rotate(18 3.157 -.5)","id":"a","d":"M.5 1L0 0v1z"}}),_c('use',{attrs:{"transform":"scale(-1 1)","xlink:href":"#a","width":"100%","height":"100%"}})]),_c('use',{attrs:{"transform":"rotate(72)","xlink:href":"#b","width":"100%","height":"100%"}}),_c('use',{attrs:{"transform":"rotate(-72)","xlink:href":"#b","width":"100%","height":"100%"}}),_c('use',{attrs:{"transform":"rotate(144)","xlink:href":"#b","width":"100%","height":"100%"}}),_c('use',{attrs:{"transform":"rotate(-144)","xlink:href":"#b","width":"100%","height":"100%"}})])])
          )
        }
      }
    